import React, { useState, useEffect } from 'react';

function RealTimeClock() {
    const [time, setTime] = useState(new Date().toLocaleTimeString());

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(new Date().toLocaleTimeString());
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);

    return <div className="clock" style={{ fontSize: "18px", fontWeight: "bold", color: "#f5f1eb", backgroundColor: "#4e4e4e", marginRight: "20px" }}>{time}</div>;
}

export default RealTimeClock;